import { z } from 'zod';

import {
  COVERAGE_STATUSES,
  PRAYER_SLOTS,
  type CoverageStatus,
  type PrayerSlot,
} from '@/shared/model/enums';

/** A coverage request as returned by match_requests_for_provider (feed row). */
export interface MatchedRequest {
  readonly id: string;
  readonly masjidName: string | null;
  readonly masjidCity: string | null;
  readonly status: CoverageStatus;
  readonly startDate: string;
  readonly endDate: string;
  readonly prayerSlots: readonly PrayerSlot[];
  readonly notes: string | null;
  readonly distanceKm: number | null;
  readonly availabilityScore: number;
  readonly score: number;
}

const rowSchema = z.object({
  id: z.string(),
  masjid_name: z.string().nullable(),
  masjid_city: z.string().nullable(),
  status: z.enum(COVERAGE_STATUSES),
  start_date: z.string(),
  end_date: z.string(),
  prayer_slots: z.array(z.enum(PRAYER_SLOTS)),
  notes: z.string().nullable(),
  distance_km: z.number().nullable(),
  availability_score: z.number(),
  score: z.number(),
});

export function mapMatchedRequest(row: unknown): MatchedRequest {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    masjidName: r.masjid_name,
    masjidCity: r.masjid_city,
    status: r.status,
    startDate: r.start_date,
    endDate: r.end_date,
    prayerSlots: r.prayer_slots,
    notes: r.notes,
    distanceKm: r.distance_km,
    availabilityScore: r.availability_score,
    score: r.score,
  };
}
